/**
 * @desc 模块列表
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<Array<string>>;
export function request(appCode: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/api/module/${appCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
